var map = {
	"./20250227-173529.png": 4259,
	"./20250227-173559.png": 9054,
	"./20250305-225246.png": 240,
	"./20250305-225308.png": 6464,
	"./红绿灯提示-红灯.png": 4237,
	"./红绿灯提示-绿灯.png": 8318,
	"./红绿灯提示-黄灯.png": 1227,
	"./红绿灯提示.png": 6713,
	"./限速提示-限速100.png": 1417,
	"./限速提示-限速120.png": 5100,
	"./限速提示-限速40.png": 5502,
	"./限速提示-限速60.png": 9476,
	"./限速提示-限速80.png": 506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1959;